// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SMS Verification page — fully scoped */

.smsv-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 20px;
  max-width: 1150px;
  margin: 0 auto;
  height: 100vh;
}

.smsv-page *,
.smsv-page *::before,
.smsv-page *::after {
  box-sizing: border-box;
}

.smsv-page__crumbs {
  margin-bottom: 18px;
}

.smsv-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8E939C;
  font-size: 15px;
  font-weight: 500;
}

.smsv-page__crumbItem--active {
  color: #dfdfdf;
  font-weight: 700;
}

body.light_theme .smsv-page__crumbItem--active {
  color: #101828;
}

.smsv-page__crumbSep {
  color: #8E939C;
}

.smsv-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.smsv-page__crumbLink:hover {
  color: #dddddd;
  text-decoration: underline;
  text-underline-offset: 3px;
}

body.light_theme .smsv-page__crumbLink:hover {
  color: #101828;
}

.smsv-page__title {
  margin: 0 0 30px;
  text-align: left;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #e3e3e3;
}

body.light_theme .smsv-page__title {
  color: #101828;
}

.smsv-form {
  width: 600px;
  max-width: 100%;
  margin: 50px auto;
  text-align: left;
  overflow: visible;
}

.smsv-field {
  display: block;
  margin-top: 18px;
}

.smsv-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #dfdfdf;
  margin-bottom: 5px;
}

body.light_theme .smsv-label {
  color: #101828;
}

.smsv-phoneRow {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f5f6f70a;
  border: 1px solid #ffffff1f;
  border-radius: 8px;
  height: 54px;
  position: relative;
  overflow: visible;
}

body.light_theme .smsv-phoneRow {
  background-color: #F5F6F7;
}

.smsv-countryBtn {
  padding: 0px 0px 0px 12px;
  border-radius: 0px;
  background-color: transparent;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  flex-shrink: 0;
}

.smsv-countrySelect {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 100%;
}

.smsv-countryMenu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 220px;
  padding: 8px;
  background: #fff;
  border: 1px solid #e6e8ec;
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  z-index: 9999;
  max-height: 340px;
  overflow: auto;
  overscroll-behavior: contain;
}

.smsv-countryOption {
  width: 100%;
  border: none;
  background: transparent;
  border-radius: 10px;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  text-align: left;
}

.smsv-countryOption:hover {
  background: #f6f7f9;
}

.smsv-countryOption.is-active {
  background: rgba(172, 138, 80, 0.12);
}

.smsv-countryLabel {
  flex: 1 1 auto;
  font-size: 14px;
  font-weight: 600;
  color: #101828;
}

.smsv-countryCode {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
}

.smsv-flag {
  font-size: 16px;
  color: #fff;
}

body.light_theme .smsv-flag {
  color: #101010;
}

.smsv-code {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

body.light_theme .smsv-code {
  color: #0e0e0e;
}

.smsv-caret {
  color: #717171;
  font-size: 12px;
}

.smsv-input {
  width: 100%;
  height: 31px;
  border-radius: 0px;
  border: 1px solid var(--smsv-border);
  background: none;
  padding: 0 10px;
  padding-right: 20px;
  font-weight: 500;
  font-size: 14px;
  color: #84888C;
  outline: none;
  border-left: 1px solid #c3c6c83d;
  margin-left: 7px;
}

.smsv-input::placeholder {
  color: #9ca3af;
}


.smsv-smsRow .smsv-input {
  border-left: none;
  padding: 0px 5px;
}

.smsv-smsRow {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #ffffff0a;
  border: 1px solid #ffffff2b;
  border-radius: 8px;
  height: 54px;
  padding: 0px 10px;
}

body.light_theme .smsv-smsRow {
  background-color: #F5F6F7;
}

.smsv-input--sms {
  flex: 1 1 auto;
}

.smsv-sendBtn {
  /* height: 44px; */
  padding: 0 12px;
  border-radius: 0px;
  border: none;
  background: none;
  color: #AC8A50;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
}

.smsv-hint {
  margin-top: 7px;
  font-size: 14px;
  color: #AAAAAA;
  font-weight: 500;
}

.smsv-confirmBtn {
  width: 100%;
  height: 52px;
  margin-top: 20px;
  border: none;
  border-radius: 999px;
  background: #303236;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}

.smsv-confirmBtn:hover {
  opacity: 0.8;
}

/* Security Verification popup (opened from Confirm) */
.smsv-secverify-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 100000010;
}

body.light_theme .smsv-secverify-overlay {
  background: rgb(255 255 255 / 20%);
}

.smsv-secverify-modal {
  width: 606px;
  max-width: 92vw;
  border-radius: 20px;
  background: #181a20;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);
  padding: 32px 24px;
  position: relative;
  text-align: left;
}

body.light_theme .smsv-secverify-modal {
  background: #ffffffd6;
  border: 1px solid #eef2f6;
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.18);
}

.smsv-secverify-close {
  position: absolute;
  top: 16px;
  right: 18px;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.smsv-secverify-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .smsv-secverify-close {
  color: #111827;
}

body.light_theme .smsv-secverify-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.smsv-secverify-title {
  margin: 0;
  padding-right: 44px;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: -0.02em;
}

body.light_theme .smsv-secverify-title {
  color: #111827;
}

.smsv-secverify-subtitle {
  margin: 8px 0 18px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #84888C;
  max-width: 760px;
}

.smsv-secverify-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  padding-top: 10px;
}

.smsv-secverify-labelRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.smsv-secverify-label {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 6px;
  display: block;
}

body.light_theme .smsv-secverify-label {
  color: #070808;
}

.smsv-secverify-link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #fcd535;
  cursor: pointer;
}

.smsv-secverify-link:hover {
  color: #e0be2f;
}

body.light_theme .smsv-secverify-link {
  color: #AC8A50;
}

body.light_theme .smsv-secverify-link:hover {
  color: #b08d52;
}

.smsv-secverify-inputWrap {
  position: relative;
  margin-bottom: 14px;
}

.smsv-secverify-input {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #1e2329;
  padding: 0 44px 0 14px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  outline: none;
}

.smsv-secverify-input:focus {
  border-color: #fcd535;
  box-shadow: 0 0 0 3px rgba(252, 213, 53, 0.15);
}

body.light_theme .smsv-secverify-input {
  border: 1px solid #e5e7eb;
  background: #EDEEEF;
  color: #111827;
}

body.light_theme .smsv-secverify-input:focus {
  border-color: #707070;
  box-shadow: 0 0 0 3px rgb(186 186 186 / 15%);
}

.smsv-secverify-input::placeholder {
  color: #9ca3af;
  font-weight: 500;
}

.smsv-secverify-eye {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #84888C;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s ease, color 0.15s ease;
}

.smsv-secverify-eye:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .smsv-secverify-eye {
  color: #9ca3af;
}

body.light_theme .smsv-secverify-eye:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #6b7280;
}

.smsv-secverify-timer {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 700;
  color: #84888C;
}

body.light_theme .smsv-secverify-timer {
  color: #9ca3af;
}

.smsv-secverify-helper {
  margin: 2px 0 10px;
  font-size: 12px;
  font-weight: 600;
  color: #84888C;
}

body.light_theme .smsv-secverify-helper {
  color: #6b7280;
}

.smsv-secverify-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 6px;
  padding-top: 6px;
}

.smsv-secverify-unable {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #fcd535;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

body.light_theme .smsv-secverify-unable {
  color: #ac8a50;
}

.smsv-secverify-confirm {
  width: 435px;
  max-width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #fcd535;
  color: #0c0d10;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.smsv-secverify-confirm:hover {
  background: #e0be2f;
}

body.light_theme .smsv-secverify-confirm {
  background: #2d2e32;
  color: #fff;
  font-weight: 500;
}

body.light_theme .smsv-secverify-confirm:hover {
  background: #1a1b1f;
}


@media (max-width: 767px) {
  .smsv-secverify-overlay {
    align-items: end;
    padding: 0px;
  }

  .smsv-secverify-modal {
    width: 100%;
    max-width: 100%;
    border-radius: 20px 20px 0px 0px;
  }

}

@media (max-width: 767px) {
  .smsv-secverify-grid {
    grid-template-columns: 1fr;
  }

  .smsv-secverify-confirm {
    width: 100%;
  }

  .smsv-secverify-footer {
    align-items: stretch;
  }

  .smsv-page {
    padding: 30px 16px 10px;
  }

  .smsv-page__title {
    font-size: 22px;
  }

  .smsv-confirmBtn {
    height: 42px;
    font-size: 14px;
  }

  .smsv-form {
    margin: 30px auto;
  }

  .smsv-secverify-title {
    font-size: 22px;
  }

  .smsv-secverify-confirm {
    height: 42px;
    font-size: 14px;
  }

  .settings-modal__btn {
    padding: 10px 16px;
    font-size: 14px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/smsVerification.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;AAEF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;AAEF","sourcesContent":["/* SMS Verification page — fully scoped */\n\n.smsv-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 20px;\n  max-width: 1150px;\n  margin: 0 auto;\n  height: 100vh;\n}\n\n.smsv-page *,\n.smsv-page *::before,\n.smsv-page *::after {\n  box-sizing: border-box;\n}\n\n.smsv-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.smsv-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8E939C;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.smsv-page__crumbItem--active {\n  color: #dfdfdf;\n  font-weight: 700;\n}\n\nbody.light_theme .smsv-page__crumbItem--active {\n  color: #101828;\n}\n\n.smsv-page__crumbSep {\n  color: #8E939C;\n}\n\n.smsv-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.smsv-page__crumbLink:hover {\n  color: #dddddd;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\nbody.light_theme .smsv-page__crumbLink:hover {\n  color: #101828;\n}\n\n.smsv-page__title {\n  margin: 0 0 30px;\n  text-align: left;\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: 0px;\n  color: #e3e3e3;\n}\n\nbody.light_theme .smsv-page__title {\n  color: #101828;\n}\n\n.smsv-form {\n  width: 600px;\n  max-width: 100%;\n  margin: 50px auto;\n  text-align: left;\n  overflow: visible;\n}\n\n.smsv-field {\n  display: block;\n  margin-top: 18px;\n}\n\n.smsv-label {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #dfdfdf;\n  margin-bottom: 5px;\n}\n\nbody.light_theme .smsv-label {\n  color: #101828;\n}\n\n.smsv-phoneRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #f5f6f70a;\n  border: 1px solid #ffffff1f;\n  border-radius: 8px;\n  height: 54px;\n  position: relative;\n  overflow: visible;\n}\n\nbody.light_theme .smsv-phoneRow {\n  background-color: #F5F6F7;\n}\n\n.smsv-countryBtn {\n  padding: 0px 0px 0px 12px;\n  border-radius: 0px;\n  background-color: transparent;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.smsv-countrySelect {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n}\n\n.smsv-countryMenu {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 220px;\n  padding: 8px;\n  background: #fff;\n  border: 1px solid #e6e8ec;\n  border-radius: 12px;\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);\n  z-index: 9999;\n  max-height: 340px;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.smsv-countryOption {\n  width: 100%;\n  border: none;\n  background: transparent;\n  border-radius: 10px;\n  padding: 10px 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.smsv-countryOption:hover {\n  background: #f6f7f9;\n}\n\n.smsv-countryOption.is-active {\n  background: rgba(172, 138, 80, 0.12);\n}\n\n.smsv-countryLabel {\n  flex: 1 1 auto;\n  font-size: 14px;\n  font-weight: 600;\n  color: #101828;\n}\n\n.smsv-countryCode {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.smsv-flag {\n  font-size: 16px;\n  color: #fff;\n}\n\nbody.light_theme .smsv-flag {\n  color: #101010;\n}\n\n.smsv-code {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n}\n\nbody.light_theme .smsv-code {\n  color: #0e0e0e;\n}\n\n.smsv-caret {\n  color: #717171;\n  font-size: 12px;\n}\n\n.smsv-input {\n  width: 100%;\n  height: 31px;\n  border-radius: 0px;\n  border: 1px solid var(--smsv-border);\n  background: none;\n  padding: 0 10px;\n  padding-right: 20px;\n  font-weight: 500;\n  font-size: 14px;\n  color: #84888C;\n  outline: none;\n  border-left: 1px solid #c3c6c83d;\n  margin-left: 7px;\n}\n\n.smsv-input::placeholder {\n  color: #9ca3af;\n}\n\n\n.smsv-smsRow .smsv-input {\n  border-left: none;\n  padding: 0px 5px;\n}\n\n.smsv-smsRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #ffffff0a;\n  border: 1px solid #ffffff2b;\n  border-radius: 8px;\n  height: 54px;\n  padding: 0px 10px;\n}\n\nbody.light_theme .smsv-smsRow {\n  background-color: #F5F6F7;\n}\n\n.smsv-input--sms {\n  flex: 1 1 auto;\n}\n\n.smsv-sendBtn {\n  /* height: 44px; */\n  padding: 0 12px;\n  border-radius: 0px;\n  border: none;\n  background: none;\n  color: #AC8A50;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.smsv-hint {\n  margin-top: 7px;\n  font-size: 14px;\n  color: #AAAAAA;\n  font-weight: 500;\n}\n\n.smsv-confirmBtn {\n  width: 100%;\n  height: 52px;\n  margin-top: 20px;\n  border: none;\n  border-radius: 999px;\n  background: #303236;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.smsv-confirmBtn:hover {\n  opacity: 0.8;\n}\n\n/* Security Verification popup (opened from Confirm) */\n.smsv-secverify-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 100000010;\n}\n\nbody.light_theme .smsv-secverify-overlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n.smsv-secverify-modal {\n  width: 606px;\n  max-width: 92vw;\n  border-radius: 20px;\n  background: #181a20;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);\n  padding: 32px 24px;\n  position: relative;\n  text-align: left;\n}\n\nbody.light_theme .smsv-secverify-modal {\n  background: #ffffffd6;\n  border: 1px solid #eef2f6;\n  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.18);\n}\n\n.smsv-secverify-close {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.smsv-secverify-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .smsv-secverify-close {\n  color: #111827;\n}\n\nbody.light_theme .smsv-secverify-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.smsv-secverify-title {\n  margin: 0;\n  padding-right: 44px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .smsv-secverify-title {\n  color: #111827;\n}\n\n.smsv-secverify-subtitle {\n  margin: 8px 0 18px;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 400;\n  color: #84888C;\n  max-width: 760px;\n}\n\n.smsv-secverify-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 6px;\n  padding-top: 10px;\n}\n\n.smsv-secverify-labelRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.smsv-secverify-label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 6px;\n  display: block;\n}\n\nbody.light_theme .smsv-secverify-label {\n  color: #070808;\n}\n\n.smsv-secverify-link {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fcd535;\n  cursor: pointer;\n}\n\n.smsv-secverify-link:hover {\n  color: #e0be2f;\n}\n\nbody.light_theme .smsv-secverify-link {\n  color: #AC8A50;\n}\n\nbody.light_theme .smsv-secverify-link:hover {\n  color: #b08d52;\n}\n\n.smsv-secverify-inputWrap {\n  position: relative;\n  margin-bottom: 14px;\n}\n\n.smsv-secverify-input {\n  width: 100%;\n  height: 42px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: #1e2329;\n  padding: 0 44px 0 14px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  outline: none;\n}\n\n.smsv-secverify-input:focus {\n  border-color: #fcd535;\n  box-shadow: 0 0 0 3px rgba(252, 213, 53, 0.15);\n}\n\nbody.light_theme .smsv-secverify-input {\n  border: 1px solid #e5e7eb;\n  background: #EDEEEF;\n  color: #111827;\n}\n\nbody.light_theme .smsv-secverify-input:focus {\n  border-color: #707070;\n  box-shadow: 0 0 0 3px rgb(186 186 186 / 15%);\n}\n\n.smsv-secverify-input::placeholder {\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.smsv-secverify-eye {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.smsv-secverify-eye:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .smsv-secverify-eye {\n  color: #9ca3af;\n}\n\nbody.light_theme .smsv-secverify-eye:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #6b7280;\n}\n\n.smsv-secverify-timer {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  font-size: 12px;\n  font-weight: 700;\n  color: #84888C;\n}\n\nbody.light_theme .smsv-secverify-timer {\n  color: #9ca3af;\n}\n\n.smsv-secverify-helper {\n  margin: 2px 0 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #84888C;\n}\n\nbody.light_theme .smsv-secverify-helper {\n  color: #6b7280;\n}\n\n.smsv-secverify-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 6px;\n  padding-top: 6px;\n}\n\n.smsv-secverify-unable {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fcd535;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\nbody.light_theme .smsv-secverify-unable {\n  color: #ac8a50;\n}\n\n.smsv-secverify-confirm {\n  width: 435px;\n  max-width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 999px;\n  background: #fcd535;\n  color: #0c0d10;\n  font-size: 17px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.smsv-secverify-confirm:hover {\n  background: #e0be2f;\n}\n\nbody.light_theme .smsv-secverify-confirm {\n  background: #2d2e32;\n  color: #fff;\n  font-weight: 500;\n}\n\nbody.light_theme .smsv-secverify-confirm:hover {\n  background: #1a1b1f;\n}\n\n\n@media (max-width: 767px) {\n  .smsv-secverify-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .smsv-secverify-modal {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 20px 20px 0px 0px;\n  }\n\n}\n\n@media (max-width: 767px) {\n  .smsv-secverify-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .smsv-secverify-confirm {\n    width: 100%;\n  }\n\n  .smsv-secverify-footer {\n    align-items: stretch;\n  }\n\n  .smsv-page {\n    padding: 30px 16px 10px;\n  }\n\n  .smsv-page__title {\n    font-size: 22px;\n  }\n\n  .smsv-confirmBtn {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .smsv-form {\n    margin: 30px auto;\n  }\n\n  .smsv-secverify-title {\n    font-size: 22px;\n  }\n\n  .smsv-secverify-confirm {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .settings-modal__btn {\n    padding: 10px 16px;\n    font-size: 14px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
